import { IPageSOBP, NeoStroke } from "@/neolab-libs/nl-lib3-common";
import { createEmitter } from "./EventBus";

// Event types for USB device management
export interface USBReportedBatchItem {
  userCode: string;
  range: { start: IPageSOBP; end: IPageSOBP };
  strokes: NeoStroke[];
  submissionCode?: string;
}

export interface USBDeviceEvents {

  // Device state changes
  "usb-device-state-completed": {
    mac: string;
  };

  // Request all rows to report their current batch upload item
  "usb-request-batch-items": {};

  // Each row reports its current batch upload item
  "usb-report-batch-item": {
    mac: string;
    item: USBReportedBatchItem | null;
  };

  // Request all rows to delete their local offline files after successful processing
  "usb-request-delete-files": {};

}

// Global event bus instance for USB devices
export const usbDeviceEventBus = createEmitter<USBDeviceEvents>();